import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    overflowY: 'auto',
    height: '100%',
    width: '100%',
    backgroundColor: '#F7FAFD',
    position: 'relative',
  },
  innerContainer: {
    paddingTop: '20px',
    width: '90%',
    margin: '0 auto',
    height: '100%',
  },
  header: {
    maxWidth: '700px',
    margin: '0 auto',
  },
  subTitle: {
    fontFamily: 'Montserrat, sans-serif',
    color: '#171D25',
    maxWidth: '900px',
    margin: '20px auto 50px auto',
    fontWeight: 600,
    lineHeight: '15px',
    fontSize: '12px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '5%',
      paddingRight: '5%',
    },
  },
  title: {
    color: '#2C1482',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: '2.5rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem',
      paddingLeft: '5%',
      paddingRight: '5%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
    },
  },
  main: {
    backgroundColor: 'transparent',
  },
}));
